import { Locale } from '@wyz/types';
import { isNil } from 'lodash-es';

export function formatPrice(
  amount?: number | null,
  {
    locale,
    fallback,
    currency,
    options,
  }: {
    locale?: Locale;
    fallback?: string;
    currency?: string;
    options?: Intl.NumberFormatOptions;
  } = {},
) {
  if (isNil(amount)) {
    return fallback;
  }
  return new Intl.NumberFormat(locale, {
    style: currency ? 'currency' : undefined,
    currency: currency,
    currencyDisplay: 'narrowSymbol',
    ...options,
  }).format(amount);
}

export const calculatePrice = (price?: number, bf?: number) => {
  if (isNil(price) || isNil(bf)) {
    return undefined;
  }
  return price * ((100 + bf) / 100);
};

export const applyDiscount = (price?: number, percent?: number) => {
  if (isNil(price) || isNil(percent)) {
    return undefined;
  }
  return price * ((100 - percent) / 100);
};

// get currency symbol
export function getCurrencySymbol(currency: string, locale: string = 'fr-FR') {
  // local doesn't matter, we just need the currency symbol
  const res = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'narrowSymbol',
  }).format(99);
  // replace all number or letters with empty string
  return res.replace(/[0-9.,]/g, '').trim();
}

export const DEFAULT_EURO_SIGN = '€';
